import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GetQUestionParams,
  ScoringPattern,
  TestTypeTest,
  InvoiceInfoRes,
  autoReplaceStruct,
  coursesRes,
  generateQuestionStruct,
  generateQuestionStructNew,
  generatedQuestionObj,
  saveTestStruct,
  scoringSectionResBeforeParse,
  searchQuestionRes,
  subTopicByScoringAndTestId,
  testType,
  GetQUestionParamsInQuestionBank,
  StudentProgressBatchesRes,
  StudentProgressSearchRequest,
  StudentProgressSearchResponse,
  DuplicateTestRequest,
  BatchScheduleEventsRes,
  AdminBatchScheduleEventsRes,
  UpdateBatchScheduleEventReq,
  DeleteBatchScheduleEventReq
} from '../constants/constants';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
// import { GetQUestionParams } from "./constants/constants";

@Injectable({
  providedIn: 'root'
})
export class GlobalApiService {
  constructor(
    public http: HttpClient,
    private commonService: CommonService
  ) {}

  getAllUsers(filterData: any) {
    return this.http.post('/api/users', filterData, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getNotes(name: any, status: any, orderType: any) {
    return this.http.get(
      `/api/get_notes?status=${status}&name=${name}&order=${orderType}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  createNote(data: any) {
    return this.http.post('/api/create_note', data, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  updateNotes(data: any) {
    return this.http.put('/api/batch_update_note_status', data, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getAllFiles() {
    return this.http.get('/api/s3/get_all_files', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  uploadFiles(formData: any) {
    return this.http.post('/api/upload_files', formData, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getFileUrl(fileId: any) {
    return this.http.get(`/api/s3/getfile?file_id=${fileId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getAllStudents() {
    return this.http.get('/api/get_all_students', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  createEditBatch(data: any) {
    return this.http.post('/api/create_edit_batch', data, this.commonService.getHeaders());
  }

  getBatchByBatchId(batchId: number) {
    return this.http.get(`/api/get_batch_by_batchid?batchId=${batchId}`, this.commonService.getHeaders());
  }

  getBatchScheduleEventsByBatchId(
    batchId: number
  ): Observable<AdminBatchScheduleEventsRes> {
    return this.http.get<AdminBatchScheduleEventsRes>(
      `/api/admin/get_batch_schedule_events_by_batchid?batchId=${batchId}`,
      this.commonService.getHeaders()
    );
  }

  updateBatchScheduleEvent(data: UpdateBatchScheduleEventReq) {
    return this.http.post(
      '/api/update_batch_schedule_event',
      data,
      this.commonService.getHeaders()
    );
  }

  deleteBatchScheduleEvent(data: DeleteBatchScheduleEventReq) {
    return this.http.post(
      '/api/delete_batch_schedule_event',
      data,
      this.commonService.getHeaders()
    );
  }

  getAllBatches() {
    return this.http.get('/api/get_all_batch', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getUserFiles(userId: any, recentDate: any) {
    return this.http.get(
      `/api/get_assigned_files?user_id=${userId}&recent_date=${recentDate}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  assignFiles(data: any) {
    return this.http.post('/api/assign_files', data, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  saveQuestions(data: any) {
    return this.http.post('/api/save_question', data, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }
  getQuestions(id: number) {
    return this.http.get(`/api/get_question?question_id=${id}`, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }
  getOptions(id: number) {
    return this.http.get(`/api/get_question_options?question_id=${id}`, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getSectionsByTestTypeId(
    id: number
  ): Observable<scoringSectionResBeforeParse | any> {
    return this.http.get<scoringSectionResBeforeParse | any>(
      `/api/getTestSectionsByTestType?test_type_id=${id}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  getScoringSectionsByTestTypeId(
    id: number
  ): Observable<scoringSectionResBeforeParse | any> {
    return this.http.get<scoringSectionResBeforeParse | any>(
      `/api/getScoringSectionsByTestType?test_type_id=${id}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  getTopicsAndSubTopics(sectionId: number, testTypeId: number) {
    return this.http.get(
      `/api/get_topic_subtopic_score_sectionwise?scoring_section_id=${sectionId}&test_type_id=${testTypeId}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  getTopicsAndSubTopicsByTestSection(tst_id: number) {
    return this.http.get(`/api/get_topic_subtopic_by_tst?tst_id=${tst_id}`, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getDifficultyLevels() {
    return this.http.get('/api/difficulty_levels', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getAllTutors() {
    return this.http.get('/api/get_all_tutors', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getQuestionsWithParams(
    params: GetQUestionParams
  ): Observable<searchQuestionRes | any> {
    return this.http.get<searchQuestionRes | any>(
      `/api/searchQuestions?topicId=${params.topicId}${
        params.questionType !== 0 ? `&questionType=${params.questionType}` : ''
      }${
        params.difficultyLevel !== 0
          ? `&difficultyLevel=${params.difficultyLevel}`
          : ''
      }&subTopicId=${params.subTopicId}${
        params.tags ? `&tags=${params.tags}` : ''
      }${
        params.canRepeatQuestions
          ? `&canRepeatQuestions=${params.canRepeatQuestions}`
          : ''
      }${
        params.ignoredQuestionCategories
          ? `&ignoredQuestionCategories=${params.ignoredQuestionCategories}`
          : ''
      }`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  getQuestionsWithParamsInQuestionBank(
    params: GetQUestionParamsInQuestionBank
  ): Observable<searchQuestionRes | any> {
    return this.http.get<searchQuestionRes | any>(
      `/api/searchQuestions?topicId=${params.topicId}${
        params.questionType !== 0 ? `&questionType=${params.questionType}` : ''
      }${
        params.difficultyLevel !== 0
          ? `&difficultyLevel=${params.difficultyLevel}`
          : ''
      }&subTopicId=${params.subTopicId}${
        params.questionCategories
          ? `&questionCategories=${params.questionCategories}`
          : ''
      }${params.tags ? `&tags=${params.tags}` : ''}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  getUser() {
    return this.http.get('/api/get_user', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      },
      responseType: 'json'
    });
  }

  getCourses(): Observable<coursesRes | any> {
    return this.http.get<coursesRes | any>('/api/get_courses', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      },
      responseType: 'json'
    });
  }

  getUserByUserId(userId: number) {
    return this.http.get(`/api/get_user_by_userid?user_id=${userId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  updateRequestedCourses(data: any) {
    return this.http.post('/api/update_requested_courses', data, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  addParentStudent(data: any) {
    return this.http.post('/api/add_parent_student', data, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getTestTypes(): Observable<testType[] | any> {
    return this.http.get<testType[] | any>('/api/test_types', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getStudentProgressStandingsBatches(
    courseId: number
  ): Observable<StudentProgressBatchesRes> {
    return this.http.get<StudentProgressBatchesRes>(
      `/api/adminDashboard/getBatches?courseId=${courseId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  searchStudentProgressStandings(
    searchData: StudentProgressSearchRequest
  ): Observable<StudentProgressSearchResponse> {
    return this.http.post<StudentProgressSearchResponse>(
      '/api/adminDashboard/search',
      searchData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  updateQuestion(questionData: any, questionId: number) {
    return this.http.put(`/api/update_question/${questionId}`, questionData, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  saveLearningModule(moduleData: any) {
    return this.http.post('/api/learningModule/save', moduleData, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  updateLearningModule(moduleId: string, moduleData: any) {
    return this.http.put(`/api/learningModule/update/${moduleId}`, moduleData, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getLearningModule(
    courseId: number,
    sectionId: number,
    topicId: number,
    subTopicId: number
  ) {
    return this.http.get(
      `/api/learningModule/get?topicId=${topicId}&subTopicId=${subTopicId}&courseTypeId=${courseId}&sectionId=${sectionId}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // Changed to number from string -- w.r.t API (as Backend API is accepting number)
  getLesson(subTopicId: number) {
    return this.http.get(
      `/api/learningModule/getbystudent?subTopicId=${subTopicId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  uploadImage(formData: any) {
    return this.http.post('/api/upload_images', formData, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getImages(listImages: string[]) {
    return this.http.get(`/api/get_images?listImages=${listImages.join()}`, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getStudentCourses(studentId: number, isParent: boolean) {
    let studentCoursesEndPoint = isParent
      ? `/api/student_courses?student_id=${studentId}`
      : `/api/student_courses?student_id=${studentId}`;
    return this.http.get(studentCoursesEndPoint, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getSubtopicsForStudent(
    sectionId: number,
    studentId: number,
    isParent: boolean
  ) {
    let availableModulesEndpoint = isParent
      ? `/api/learningModule/available_modules?sectionId=${sectionId}&student_id=${studentId}`
      : `/api/learningModule/available_modules?sectionId=${sectionId}`;
    return this.http.get(availableModulesEndpoint, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  submitAnswer(data: any) {
    return this.http.post(`/api/studentLearningAttemptedQuestions/save`, data, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getSubmittedAnswers(
    moduleId: string,
    questions: number[],
    studentId: number
  ) {
    const url = `/api/studentLearningAttemptedQuestions/get/${moduleId}?questionIds=${[
      ...new Set(questions)
    ].join(',')}&studentId=${studentId}`;

    return this.http.get(url, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  updateLessonStatus(subTopicId: number, status: number) {
    return this.http.post(
      `/api/studentLearningProgress/save`,
      {
        status,
        subTopicId
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  putLessonStatus(progressId: string, subTopicId: number, status: number) {
    return this.http.put(
      `/api/studentLearningProgress/update/${progressId}`,
      {
        status,
        subTopicId
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** Get created test details (for edit test)
  getCreatedTest(testId: number): Observable<saveTestStruct> {
    return this.http.get<saveTestStruct>(
      `/api/testGeneration/getTest/${testId}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** API for getting multiple questions using Question Id's (Join the Question Id's using (,))
  getMultipleQuestions(
    joinedQuestionIds: string
  ): Observable<generatedQuestionObj[]> {
    return this.http.get<generatedQuestionObj[]>(
      `/api/getQuestions?questionIds=${joinedQuestionIds}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** API for updating an existing test
  updateExistingTest(testId: number, data: saveTestStruct) {
    return this.http.put(`/api/testGeneration/updateTest/${testId}`, data, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }
  getStudentClasses(studentId: any) {
    return this.http.get(`/api/get_student_classes?studentId=${studentId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }
  getStudentBatchScheduleEvents(
    studentId: number
  ): Observable<BatchScheduleEventsRes> {
    return this.http.get<BatchScheduleEventsRes>(
      `/api/student/get_batch_schedule_events_by_studentid?studentId=${studentId}`,
      this.commonService.getHeaders()
    );
  }
  uploadQuestionVideos(questionId: number, formData: FormData) {
    return this.http.post(
      `/api/question-videos/upload/${questionId}`,
      formData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        },
        reportProgress: true,
        observe: 'events'
      }
    );
  }
  getQuestionVideos(questionId: number) {
    return this.http.get(`/api/question-videos/question/${questionId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }
  updateVideoStatus(videoId: number, isActive: boolean) {
    return this.http.put(
      `/api/question-videos/${videoId}/status?isActive=${isActive ? 1 : 0}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }
    );
  }
  updateContentVideoStatus(videoId: number, isActive: boolean) {
    console.log('Calling Content Video Status API', videoId, isActive);

    return this.http.post(
      `/api/content-videos/${videoId}/status?isActive=${isActive}`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
          'Content-Type': 'application/json'
        }
      }
    );
  }
  uploadLearningModuleVideos(moduleId: string, formData: FormData) {
    return this.http.post(
      `/api/content-videos/learning-modules/${moduleId}/upload`,
      formData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        },
        reportProgress: true,
        observe: 'events'
      }
    );
  }
  getLearningModuleVideos(moduleId: string) {
    return this.http.get(`/api/content-videos/learning-modules/${moduleId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }
  uploadWorkshopVideos(workshopId: string, formData: FormData) {
    console.log('API Call - uploadWorkshopVideos:', workshopId);
    return this.http.post(
      `/api/content-videos/workshops/${workshopId}/upload`,
      formData,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        },
        reportProgress: true,
        observe: 'events'
      }
    );
  }
  getWorkshopVideos(workshopId: string) {
    return this.http.get(`/api/content-videos/workshops/${workshopId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getVideoById(videoId: number) {
    return this.http.get(`/api/content-videos/${videoId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }
  updateWorkshopVideoStatus(videoId: number, isActive: boolean) {
    return this.http.patch(
      `/api/content-videos/${videoId}/status`,
      { isActive },
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  // ** Get subTopics using scoring and test Id's
  getSubTopicsByScoringAndTestId(
    scoringTestId: number,
    testTypeId: number
  ): Observable<subTopicByScoringAndTestId[]> {
    return this.http.get<subTopicByScoringAndTestId[]>(
      `/api/subTopic/scroingSection/${scoringTestId}/testType/${testTypeId}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** Get automatically generated questions
  getQuestionsGenerated(data: any): Observable<generateQuestionStruct[]> {
    // let yo = JSON.stringify(data)
    // data = {data}
    return this.http.post<generateQuestionStruct[]>(
      `/api/testGeneration/prepareQuestionary`,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** Get automatically generated questions (New)
  getQuestionsGeneratedNew(data: any): Observable<generateQuestionStructNew[]> {
    // let yo = JSON.stringify(data)
    // data = {data}
    return this.http.post<generateQuestionStructNew[]>(
      `/api/testGeneration/prepareQuestionary`,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** Get automatically generated questions (New) (Synchronous)
  getQuestionsGeneratedNewSync(data: any): any {
    // let yo = JSON.stringify(data)
    // data = {data}
    return this.http
      .post<generateQuestionStructNew[]>(
        `/api/testGeneration/prepareQuestionary`,
        data,
        {
          headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
        }
      )
      .toPromise();
  }

  // ** Save created test
  saveTestCreation(data: saveTestStruct) {
    return this.http.post(`/api/testGeneration/saveTest`, data, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  // ** API for auto replacing questions
  autoReplaceCall(data: autoReplaceStruct): Observable<generatedQuestionObj> {
    return this.http.post<generatedQuestionObj>(
      `/api/testGeneration/testModule/question/autoReplace`,
      data,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  getPaymentTypes() {
    return this.http.get('/api/get_payment_types', {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  createPayment(paymentData: any) {
    return this.http.post(`/api/invoice/save`, paymentData, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getPaymentsForAdmin(
    studentIdORName: any,
    status: any,
    sortOrder: any,
    pageNumber: number
  ) {
    return this.http.get(
      `/api/invoice/admin/get?pageSize=15&pageNumber=${pageNumber}&${
        studentIdORName ? `studentIdORName=${studentIdORName}&` : ''
      }${status ? `status=${status}&` : ''}${
        sortOrder ? `sortOrder=${sortOrder}` : ''
      }`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  // ** Get Invoice Information (Student)
  getInvoiceInfoList(isStudent: boolean): Observable<InvoiceInfoRes> {
    let getPaymentEndpoint: string = isStudent
      ? `/api/invoice/student/get`
      : `/api/invoice/parent/get`;
    return this.http.get<InvoiceInfoRes>(getPaymentEndpoint, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  getPaymentUrl(invoiceId: string) {
    return this.http.post(
      `/api/invoice/student/${invoiceId}/payNow`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  payByInstallments(invoiceId: string) {
    return this.http.post(
      `/api/invoice/student/${invoiceId}/subscribe`,
      {},
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  fetchPaymentDetailsForAdmin(invoiceId: string) {
    return this.http.get(`/api/invoice/paymentHistory/${invoiceId}`, {
      headers: {
        Authorization: 'Bearer ' + localStorage['accessToken']
      }
    });
  }

  getPaymentHistory(isStudent: boolean, invoiceId: string) {
    let historyOf: string = 'student';
    historyOf = isStudent ? 'student' : 'parent';
    return this.http.get(
      `/api/invoice/paymentHistory/${historyOf}/${invoiceId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  // ** API for getting test scores
  getTestScoringPattern(testId: number): Observable<ScoringPattern> {
    return this.http.get<ScoringPattern>(
      `/api/testGeneration/scoreConversion/get/${testId}`,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** API for saving test scores
  saveTestScoringPattern(
    scoringPatternDetails: ScoringPattern
  ): Observable<any> {
    return this.http.post<any>(
      `/api/testGeneration/scoreConversion/save/`,
      scoringPatternDetails,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  duplicateTest(duplicateTestDetails: DuplicateTestRequest): Observable<any> {
    return this.http.post<any>(
      `/api/testGeneration/duplicateTest`,
      duplicateTestDetails,
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  getSectionsByTestTypeIdSync(
    id: number
  ): Observable<scoringSectionResBeforeParse | any> | any {
    return this.http
      .get<scoringSectionResBeforeParse | any>(
        `/api/getTestSectionsByTestType?test_type_id=${id}`,
        {
          headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
        }
      )
      .toPromise();
  }

  getTopicsAndSubTopicsByTestSectionSync(tst_id: number): any {
    return this.http
      .get(`/api/get_topic_subtopic_by_tst?tst_id=${tst_id}`, {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      })
      .toPromise();
  }

  getTestsByTestTypeId(testTypeId: number): Observable<TestTypeTest[] | any> {
    return this.http.get<TestTypeTest[] | any>(
      `/api/get_tests_by_test_type_id?testTypeId=${testTypeId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }

  getQuestionDataForStudent(
    questionId: number,
    studentTestId: string
  ): Observable<any> {
    return this.http.get(
      `/api/getQuestionForStudent?student_test_id=${studentTestId}&question_id=${questionId}`,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage['accessToken']
        }
      }
    );
  }
  updateVideoDisplayOrderBatch(
    videos: { videoId: number; displayOrder: number }[]
  ): Observable<any> {
    const url = `/api/question-videos/display-order/batch`;
    return this.http.put(url, videos, this.commonService.getHeaders());
  }

  /* API for updating invoice */
  updatePayment(paymentInfo: any): Observable<any> {
    return this.http.put(
      `/api/invoice/update`,
      paymentInfo,
      this.commonService.getHeaders()
    );
  }

  reTakeTest(data: {
    test_id: number;
    is_pause_allowed: number;
  }): Observable<any> {
    return this.http.post(
      `/api/self_assign_test`,
      data,
      this.commonService.getHeaders()
    );
  }

  // ** To update the payment method
  updatePaymentMethod(invoiceId: string): Observable<any> {
    return this.http.post<any>(
      `/api/payment_method/update_payment_method/${invoiceId}`,
      {},
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** To confirm the updation of payment method
  confirmTheUpdatePaymentMethod(
    invoiceId: string,
    cSessionId: string
  ): Observable<any> {
    return this.http.post<any>(
      `/api/payment_method/confirm_payment_method/`,
      {
        invoiceId: invoiceId,
        cSessionId: cSessionId
      },
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** To download the invoice
  downloadInvoice(receiptId: string): Observable<any> {
    return this.http.get<any>(`/api/invoice/download/${receiptId}`, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }

  // ** To cancel a subscription
  cancelSubscription(
    subscriptionId: string,
    refundType: 'NO_REFUND' | 'LAST_PAID_AMOUNT'
  ): Observable<any> {
    return this.http.post<any>(
      `/api/invoice/admin/cancel/${subscriptionId}/?refundType=${refundType}`,
      {},
      {
        headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
      }
    );
  }

  // ** To delete an invoice
  deleteInvoice(invoiceId: string): Observable<any> {
    return this.http.delete<any>(`/api/invoice/delete/${invoiceId}`, {
      headers: { Authorization: 'Bearer ' + localStorage['accessToken'] }
    });
  }
}
